import { render, staticRenderFns } from "./AddYoutubeDialog.vue?vue&type=template&id=55b3c51c&scoped=true&"
import script from "./AddYoutubeDialog.vue?vue&type=script&lang=js&"
export * from "./AddYoutubeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddYoutubeDialog.vue?vue&type=style&index=0&id=55b3c51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3c51c",
  null
  
)

export default component.exports